<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :canGoBack="false" @pressedGoHome="$router.push('/home')" @pressedGoBack="$router.push('/home')"></spot-header>

		<ion-content :fullscreen="true"> <!--v-if="isActive"-->
			<ion-progress-bar type="indeterminate" v-if="!isActive"></ion-progress-bar>
			<div id="actionArea" v-else>
				<web-socket-reader crReplacedChar="|" @readedBarcode="onReadedBarcode" @readerError="onReaderError"></web-socket-reader>
				<spot-select-custom
					:ref="projectField.name"
					:label="projectField.text"
					:allignLabel="projectField.allignLabel"
					:required="projectField.required"
					:placeholder="getPlaceHolder(projectField)"
					:enabled="getEnabled(projectField, projectField.enabled)"
					:enabledExtraButtons="getEnabled(projectField, projectField.enabledExtraButtons)"
					:value="projectField.value"
					:options="tablesData.projects"
					:optionField="projectField.refField"
					:validationState="projectField.validationState"
					:canAddItem="projectField.canAddItem"
					:canRefreshList="projectField.canRefresh"
					:canUnlock="projectField.canUnlock"
					:custom-label="customProject"
					:selectedLabel="selectedText"
					:deselectLabel="deselectText"
					:selectLabel="selectText"
					@selected="assignedProject"
					@unselected="resetProject">
				</spot-select-custom>
				<spot-select-custom
					:ref="documentField.name"
					:label="documentField.text"
					:allignLabel="documentField.allignLabel"
					:required="documentField.required"
					:placeholder="getPlaceHolder(documentField)"
					:enabled="getEnabled(documentField, documentField.enabled)"
					:enabledExtraButtons="getEnabled(documentField, documentField.enabledExtraButtons)"
					:value="documentField.value"
					:options="tablesData.documents"
					:optionField="documentField.refField"
					:validationState="documentField.validationState"
					:canAddItem="documentField.canAddItem"
					:canRefreshList="documentField.canRefresh"
					:canUnlock="documentField.canUnlock"
					:custom-label="customDocument"
					:selectedLabel="selectedText"
					:deselectLabel="deselectText"
					:selectLabel="selectText"
					@selected="assignedDocument"
					@unselected="resetDocument">
				</spot-select-custom>
				<spot-select-custom
					:ref="referenceItemField.name"
					:label="referenceItemField.text"
					:allignLabel="referenceItemField.allignLabel"
					:required="referenceItemField.required"
					:placeholder="getPlaceHolder(referenceItemField)"
					:enabled="getEnabled(referenceItemField, referenceItemField.enabled)"
					:enabledExtraButtons="getEnabled(referenceItemField, referenceItemField.enabledExtraButtons)"
					:value="referenceItemField.value"
					:options="tablesData.referenceItems"
					:optionField="referenceItemField.refField"
					:validationState="referenceItemField.validationState"
					:canAddItem="referenceItemField.canAddItem"
					:canRefreshList="referenceItemField.canRefresh"
					:canUnlock="referenceItemField.canUnlock"
					:custom-label="customReferenceItem"
					:selectedLabel="selectedText"
					:deselectLabel="deselectText"
					:selectLabel="selectText"
					@selected="assignedReferenceItem"
					@unselected="resetReferenceItem">
				</spot-select-custom>
				<spot-button
					v-if="settings.printerManagement == true"
					:ref="printButton.name"
					:text="printButton.text"
					:enabled="getEnabled(printButton, printButton.enabled)"
					:size="printButton.size"
					:fill="printButton.fill"
					:icon="printButton.icon"
					:expand="printButton.expand"
					:color="printButton.color"
					@clicked="openModalPrint(false)">
				</spot-button>
				<spot-button
					v-if="settings.printerManagement == true"
					:ref="reprintButton.name"
					:text="reprintButton.text"
					:enabled="getEnabled(reprintButton, reprintButton.enabled)"
					:size="reprintButton.size"
					:fill="reprintButton.fill"
					:icon="reprintButton.icon"
					:expand="reprintButton.expand"
					:color="reprintButton.color"
					@clicked="openModalReprint(false)">
				</spot-button>
				<spot-button
					:ref="confirmButton.name"
					:text="confirmButton.text"
					:enabled="getEnabled(confirmButton, confirmButton.enabled)"
					:size="confirmButton.size"
					:fill="confirmButton.fill"
					:icon="confirmButton.icon"
					:expand="confirmButton.expand"
					:color="confirmButton.color"
					@clicked="manageProject">
				</spot-button>
				<ion-modal ref="modalPrint" backdrop-dismiss="false" :is-open="isOpenModalPrint" @didDismiss="modalPrintDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ modalPrintTitle }}</ion-title>
						</ion-toolbar>
						<div lines="none" v-for="field in itemContentsModalPrint" :key="field.id" class="no-pad">
							<spot-input
								v-if="(field.inputType == 'text' || field.inputType == 'number')"
								:ref="field.name"
								:label="field.text"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="field.enabled"
								:validationState="field.validationState"
								:furtherInfo="field.furtherInfo"
								:value="field.value"
								:type="field.inputType"
								@textChanged="changedTextField(field.id, $event)">
							</spot-input>
						</div>
						<div class="flex-row-center-container">
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeModalPrint(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="!!itemContentsModalPrint[itemContentModalPrint.labelQuantity].value"
								:expand="null"
								:text="confirmText"
								@clicked="closeModalPrint(true)">
							</spot-button>
						</div>
					</ion-content>
				</ion-modal>
				<ion-modal ref="modalReprint" backdrop-dismiss="false" :is-open="isOpenModalReprint" @didDismiss="modalReprintDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ modalReprintTitle }}</ion-title>
						</ion-toolbar>
						<div lines="none" v-for="field in itemContentsModalReprint" :key="field.id" class="no-pad">
							<spot-select
								v-if="field.inputType == 'select'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="field.enabled"
								:enabledExtraButtons="field.enabledExtraButtons"
								:value="field.value"
								:options="tablesData.packages"
								:optionField="field.refField"
								:validationState="field.validationState"
								:canAddItem="field.canAddItem"
								:canRefreshList="field.canRefresh"
								:canUnlock="field.canUnlock"
								:selectedLabel="selectedText"
								:deselectLabel="deselectText"
								:selectLabel="selectText"
								@selected="assignedPackage"
								@unselected="resetPackage">
							</spot-select>
						</div>
						<div class="flex-row-center-container">
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeModalReprint(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="!!itemContentsModalReprint[itemContentModalReprint.labelName].value"
								:expand="null"
								:text="confirmText"
								@clicked="closeModalReprint(true)">
							</spot-button>
						</div>
					</ion-content>
				</ion-modal>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.debug">
				<div>Test Area</div>
				<!-- invece che chiamare direttamente la onReadedBarcode('1111111111111','barcode') nella buttons, chiama un funzione che fa apparire un pop-up con il codice da leggere, oppure aggiungi una spotinput per l'inseriento del codice da leggere-->
				<spot-button
					fill="outline"
					size="large"
					color="primary"
					:enabled="true"
					text="Simulate Scan"
					@clicked="onReadedBarcode('1111111111111','barcode')">
				</spot-button>
				<div v-for="field in fields" :key="field.id">
					{{ field.name }} = {{ field.value }}
				</div>
			</div>
		</ion-content>

	</ion-page>
</template>

<style scoped>
	ion-modal {
		--height: 40%;
		--width: 80%;
		--border-radius: 16px;
		--box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	}
	ion-modal::part(backdrop) {
		background: var(--ion-color-medium);
		opacity: 1;
	}
	ion-modal ion-toolbar {
		--background: var(--ion-color-primary);
		--color: white;
	}
	.flex-row-center-container {
		margin-top: 0.2em;
		text-align: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
</style>

<script>
	import { IonContent, IonPage, IonProgressBar, IonModal, IonTitle, IonToolbar} from '@ionic/vue';
	import { defineComponent } from 'vue';
	import SpotButton from '../components/SpotButton.vue';
	import SpotSelect from '../components/SpotSelect.vue';
	import SpotSelectCustom from '../components/SpotSelectCustom.vue';
	import SpotInput from '../components/SpotInput.vue';
	import SpotHeader from "../components/SpotHeader.vue";
	import WebSocketReader from '../components/WebSocketReader.vue';
	import { checkUserSession, confirmYesNo, settings, showMsgError, showMsgInfo, showMsgWarning, writeLog } from '../plugins/common.js';
	import { getPrinter, createPackage, executePrinterAction, searchDocuments, searchPackages, searchPrinter, searchRawProjects, searchProjectTypology, searchReferenceItems, tablesData/*, updateProject */} from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "SelectProject",
		props: {
			pageTitle: { type: String, default: 'Preparazione Colli' }, //'Seleziona Progetto - Articolo'
			customerOrderTitle: { type: String, default: 'placeholder.goods_issue_with_list' }, // placeholder.goods_issue_without_list
			supplierOrderTitle: { type: String, default: 'placeholder.goods_receipt_with_list' }, // placeholder.goods_receipt_without_list
			pickingListTitle: { type: String, default: 'placeholder.picking_list' },
			selectedText: { type: String, default: 'Selezionato' },
			deselectText: { type: String, default: 'annulla' },
			selectText: { type: String, default: 'seleziona' },
			// noOrdersText: { type: String, default: 'Nessun Ordine presente' },
			// newOrderText: { type: String, default: 'Nuovo Ordine' },
			// editOrderText: { type: String, default: 'Modifica Ordine'}, //'Modifica Ordine: '
			// showOrderText: { type: String, default: 'Visualizza Ordine'}, //'Visualizza Ordine: '
			undoText: { type: String, default: 'Annulla' },
			confirmText: { type: String, default: 'Conferma' },
			// unselected: { type: String, default: 'Nessuno' },
			supervisorRoleText: { type: String, default: 'supervisore' },
			messageSearchProjectTitle: { type: String, default: 'Ricerca Progetto' },
			messageSearchProjectNotFound: { type: String, default: 'Progetto non trovato!' },
			messageSearchDocumentTitle: { type: String, default: 'Ricerca Documento' },
			messageSearchDocumentNotFound: { type: String, default: 'Documento non trovato!' },
			messageSearchReferenceItemTitle: { type: String, default: 'Ricerca Articolo' },
			messageSearchReferenceItemNotFound: { type: String, default: 'Articolo non trovato!' },
			messageSearchProjectOrDocumentTitle: { type: String, default: 'Ricerca Progetto/Documento' },
			messageSearchProjectOrDocumentNotFound: { type: String, default: 'Progetto/Documento non trovato!' },
			messageSearchDocumentOrProjectTitle: { type: String, default: 'Ricerca Documento/Progetto' },
			messageSearchDocumentOrProjectNotFound: { type: String, default: 'Documento/Progetto non trovato!' },
			// messageTitleCheckTAG: { type: String, default: 'Controllo TAG' },
			// warnMultipleTAG: { type: String, default: 'Letto più di un TAG. Avvicinarsi solo al TAG da leggere e riprovare' },
			// warnInavlidTAG: { type: String, default: 'TAG letto solo in parte. Riprovare a leggere' },
			messageTitleReader: { type: String, default: 'Lettura Barcode' },
			errorReadingReader: { type: String, default: 'Errore nella lettura del barcode' },
			// confirmDeleteTitle: { type: String, default: 'Conferma Cancellazione' },
			// confirmDeleteMessage: { type: String, default: 'Confermi la cancellazione dell\'ordine corrente?' },
			messageTitleInsert: { type: String, default: "Inserimento Nuovo Collo" },
			successAddPackageMessage: { type: String, default: "Nuovi colli inseriti a sistema." },
			messageTitlePrint: { type: String, default: "Stampa Etichetta" },
			messageTitleReprint: { type: String, default: "Ristampa Etichetta" },
			//successPrintMessage: { type: String, default: "Stampa etichetta avvenuta correttamente. Etichetta: " },
			successPrintMessage: { type: String, default: "Stampa etichetta avvenuta correttamente. Etichette stampate: " },
			successReprintMessage: { type: String, default: "Ristampa etichetta avvenuta correttamente. Etichetta stampata: " },
			errorPrintMessage: { type: String, default: "Errore durante la stampa dell'etichetta" },
			// errorPrintConfirmMessage: { type: String, default: "Confermi di procedere lo stesso anche se la stampa non è avvenuta (l'etichetta non potrà essere stampata successivamente)?" },
			warningPrinterOffline: { type: String, default: "La stampante non è raggiungibile; l'etichetta non è stata stampata" },
			warningUnassignedPrinterConfirmMessage: { type: String, default: "Confermi di procedere lo stesso anche se non è stata assegnata una stampante (l'etichetta non verrà stampata)?" },
			warningNotFoundPrinterConfirmMessage: { type: String, default: "Confermi di procedere lo stesso anche se la stampante è spenta o non raggiungibile (l'etichetta non verrà stampata)?" },
		},
		components: {
			IonPage,
			IonContent,
			IonProgressBar,
			IonModal,
			IonTitle,
			IonToolbar,
			SpotHeader,
			SpotSelect,
			SpotSelectCustom,
			SpotInput,
			SpotButton,
			WebSocketReader,
		},
		data: () => ({
			isActive: null,
			field: {
				project: 0,
				document: 1,
				referenceItem: 2,
				print: 3,
				reprint: 4,
				confirm: 5,
			},
			fields: [
				{ id: 0, name: 'project', text: 'Progetto', enabled: null, enabledExtraButtons: null, allignLabel: false, placeholder: 'Seleziona Progetto', emptyValue: 'Nessuno', inputType: 'combo', defaultValue: null, value: null, required: true, refField: 'name', validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 1, name: 'document', text: 'C-Ov/G-Proge', enabled: null, enabledExtraButtons: null, allignLabel: false, placeholder: 'Seleziona C-Ov/G-Proge', emptyValue: 'Nessuno', inputType: 'combo', defaultValue: null, value: null, required: true, refField: 'name', validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 2, name: 'referenceItem', text: 'Riferimento Padre', enabled: null, enabledExtraButtons: null, allignLabel: false, placeholder: 'Seleziona Riferimento Padre', emptyValue: 'Nessuno', inputType: 'select', defaultValue: null, value: null, required: true, refField: 'name', validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 3, name: 'print', text: 'Stampa Etichette', enabled: null, inputType: 'button', size: 'default', fill: 'solid', expand: 'block', icon: 'print', color: 'secondary' },
				{ id: 4, name: 'reprint', text: 'Ristampa Etichette', enabled: null, inputType: 'button', size: 'default', fill: 'solid', expand: 'block', icon: 'print', color: 'secondary' },
				{ id: 5, name: 'confirm', text: 'Procedi', enabled: null, inputType: 'button', size: 'default', fill: 'solid', expand: 'block', icon: 'bagAdd', color: 'primary' },
			],
			itemContentModalPrint: {
				labelQuantity: 0,
			},
			itemContentsModalPrint: [
				{ id: 0, name: 'labelQuantity', text: 'Nr. Etichette', enabled: true, placeholder: 'Inserisci Nr. Etichette', inputType: 'number',  defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
			],
			itemContentModalReprint: {
				labelName: 0,
			},
			itemContentsModalReprint: [
				{ id: 0, name: 'labelName', text: 'Pacco', enabled: true, enabledExtraButtons: null, allignLabel: true, placeholder: 'Inserisci Codice Pacco', emptyValue: 'Nessuno', inputType: 'select',  defaultValue: null, value: null, required: true, refField: 'name', validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
			],
			isOpenModalPrint: false,
			isOpenModalReprint: false,
			modalPrintTitle: "Etichette da Stampare",
			modalReprintTitle: "Etichetta da Ristampare",
			modalReadOnly: null,
			// currentFieldId: 0,
			lastBarcode: null,
			isIncoming: null,
			isOutgoing: null,
			isPicking: null,
			isRevision: null,
			isLocked: null,
			isSupervisor: false,
			keepProject: null,
			savedProject: null,
			plantId: null,
			printerId: null,
			// duplicate,
			// enter,
			// reader,
			// trash,
			// brush,
			settings,
			checkUserSession,
			confirmYesNo,
			showMsgError,
			showMsgInfo,
			showMsgWarning,
			writeLog,
			searchProjectTypology,
			searchRawProjects,
			searchDocuments,
			searchReferenceItems,
			searchPackages,
			searchPrinter,
			createPackage,
			getPrinter,
			executePrinterAction,
			// updateProject,
			tablesData,
		}),
		computed: {
			// currField() { return this.fields[this.currentFieldId] },
			projectField() { return this.fields[this.field.project] },
			documentField() { return this.fields[this.field.document] },
			referenceItemField() { return this.fields[this.field.referenceItem] },
			printButton() { return this.fields[this.field.print] },
			reprintButton() { return this.fields[this.field.reprint] },
			confirmButton() { return this.fields[this.field.confirm] },
			isEmptyRequiredFields() {
				let ret = false;
				this.fields.forEach(element => {if (element.required && !element.value) ret=true});
				return ret;
			},
			canPrint() {
				return (this.settings.printerManagement && (this.printerId != null))
			}
		},
		async ionViewWillEnter() {
			// let date = new Date();
			// console.log("start ", date.toISOString());
			this.getUrlParamsAndQuery();
			this.setDefault();
			await this.getAllTablesData();
			this.isActive = true;
			// date = new Date();
			// console.log("stop ", date.toISOString());
		},
		ionViewWillLeave() {
			this.isOpenModalPrint = false;
			this.isOpenModalReprint = false;
			this.isActive=false;
		},
		methods: {
			// Settings & StartUp
			getUrlParamsAndQuery() {
				this.isIncoming = (/true/i).test(this.$route.query.incoming);
				this.isOutgoing = (/true/i).test(this.$route.query.outgoing);
				this.isPicking = (/true/i).test(this.$route.query.picking);
				this.isRevision = (/true/i).test(this.$route.query.revision);
				this.isLocked = (/true/i).test(this.$route.query.locked);
				this.keepProject = (/true/i).test(this.$route.query.keepProject);
			},
			setDefault() {
				if (this.keepProject) this.savedProject = this.fields[this.field.project].value; else this.savedProject = null;
				//this.fields.forEach(element => {if (element.id != this.field.project || this.keepProject != true) element.value = element.defaultValue});
				this.fields.forEach(element => element.value = element.defaultValue);
				this.fields.forEach(element => (element.required == true? (element.value == null ? element.validationState = false : element.validationState = true) : element.validationState = null));
				this.isSupervisor = this.checkRole();
				this.plantId = this.tablesData.currentUser.plant_id;
				this.isOpenModalPrint = false;
				this.isOpenModalReprint = false;
				this.modalReadOnly = null;
				this.lastBarcode = null;
			},
			getPlaceHolder(element) {
				return ((this.settings.showFieldsPlaceholder) ? (element.required ? element.placeholder : this.unselected ) : '')
			},
			getEnabled(element, defaultState) {
				let ret = false;
				// if(this.isActive == true) {
				if (defaultState != null) ret = defaultState;
				else {
					switch (element.id) {
						// case this.field.project:
						case this.field.project:
							ret = !!tablesData.projects
							break;
						case this.field.document:
							ret = !!this.projectField.value
							break;
						case this.field.referenceItem:
							ret = !!this.projectField.value && !! this.documentField.value
							break;
						case this.field.print:
							ret = this.canPrint && !!this.projectField.value
							break;
						case this.field.reprint:
							ret = this.canPrint && !!this.projectField.value && this.tablesData.packages.length > 0
							break;
						case this.field.confirm:
							// ret = !!this.projectField.value && !! this.documentField.value && this.referenceItemField.value
							ret = !this.isEmptyRequiredFields
							break;
					}
				}
				// }
				return ret
			},
			async getCustomLabel(element) {
				let ret = null;
				// if(this.isActive == true) {
					switch (element.id) {
						case this.field.project:
							ret = this.customProject
							break;
						case this.field.document:
							ret = this.customDocument
							break;
						// case this.field.referenceItem:
						// case this.field.confirm:
					}
				// }
				return ret
			},
			// Database
			async getAllTablesData() {
				this.tablesData.projects = [];
				this.tablesData.currentProject = null;
				this.tablesData.packages = [];
				this.tablesData.documents = [];
				this.tablesData.currentDocument = null;
				this.tablesData.referenceItems = [];
				this.tablesData.currentReferenceItem = null;
				this.tablesData.currentProjectTypology = null;
				if (this.isIncoming == true) await this.searchProjectTypology(this.supplierOrderTitle);
				if (this.isOutgoing == true) await this.searchProjectTypology(this.customerOrderTitle);
				if (this.isPicking == true) await this.searchProjectTypology(this.pickingListTitle);
				// await this.searchProjects(this.tablesData.currentProjectTypology.id, null, null, null, null, null, null, null, 'name'); //await this.searchProjects(this.tablesData.currentProjectTypology.id); //this.tablesData.currentProjectTypology.id, false, null, false
				await this.searchRawProjects(this.tablesData.currentProjectTypology.id);
				if (this.keepProject) {
					this.fields[this.field.project].value = this.savedProject;
					await this.assignedProject(this.savedProject);
				}
				if (this.settings.printerManagement == true) { //prima check this.plantId not null
					this.tablesData.printers = [];
					this.tablesData.currentPrinter = null;
					if (this.plantId != null) {
						await this.searchPrinter(null, null, this.plantId);// this.searchPrinter(true);
					}
					if (!this.tablesData.currentPrinter) {
						this.printerId = null;
						this.confirmYesNo(this.messageTitlePrint, this.warningUnassignedPrinterConfirmMessage)
						.then((data) => {
							if (data == false) {
								this.$router.push("/home");
							}
						})
					}
					else {
						this.printerId = this.tablesData.currentPrinter.id;
						if (!this.tablesData.currentPrinter.is_online) {
							this.confirmYesNo(this.messageTitlePrint, this.warningNotFoundPrinterConfirmMessage)
							.then((data) => {
								if (data == false) {
									this.$router.push("/home");
								}
							})
						}
					}
				}
			},
			customProject ({ name, customer }) {
				return name + " - " + (!customer ? "" : customer.name)
			},
			/*
			customDocument ({ name, issued_at }) {
				let issuedDate = new Date(issued_at).toLocaleDateString('it-IT');
				return name + " DEL " + issuedDate
			},
			*/
			customDocument ({ name, closed }) {
				let closedMark = this.isSupervisor ? (closed ? '(X) ' : '') : ''
				return closedMark + name
			},
			customReferenceItem ({ name, closed }) {
				let closedMark = this.isSupervisor ? (closed ? '(X) ' : '') : ''
				return closedMark + name
			},
			// Actions
			async onReadedBarcode(barcode, type, gs1Data = null) {
				this.lastBarcode = barcode;
				this.writeLog(barcode, type, gs1Data);
				await this.committedBarcode();
			},
			onReaderError(data,error) {
				this.showMsgError(data, error);
				this.showMsgWarning(this.messageTitleReader, this.errorReadingReader);
			},
			checkRole() {
				let ret = false;
				this.tablesData.currentUser.roles.forEach(element => {if (element.name.toLowerCase() == this.supervisorRoleText.toLowerCase()) ret=true});
				return ret;
			},
			openModalPrint(isReadOnly) {
				this.modalReadOnly = isReadOnly;
				this.isOpenModalPrint = true;
			},
			async closeModalPrint(saveRecord) {
				if (saveRecord == true) await this.addPackageAndPrintLabel(this.itemContentsModalPrint[this.itemContentModalPrint.labelQuantity].value);
				this.isOpenModalPrint = false;
			},
			async modalPrintDismissed() {
				this.itemContentsModalPrint[this.itemContentModalPrint.labelQuantity].value = this.itemContentsModalPrint[this.itemContentModalPrint.labelQuantity].defaultValue;
			},
			openModalReprint(isReadOnly) {
				this.modalReadOnly = isReadOnly;
				this.isOpenModalReprint = true;
			},
			async closeModalReprint(printData) {
				if (printData == true) await this.reprintLabel();
				this.isOpenModalReprint = false;
			},
			async modalReprintDismissed() {
				this.itemContentsModalReprint[this.itemContentModalReprint.labelName].value = this.itemContentsModalReprint[this.itemContentModalReprint.labelName].defaultValue;
			},
			changedTextField(fieldId, value) {
				this.itemContentsModalPrint[fieldId].value = value;
				(!value || value.length == 0)? this.itemContentsModalPrint[fieldId].validationState = false : this.itemContentsModalPrint[fieldId].validationState = true
			},
			async assignedProject(value) {
				this.tablesData.currentProject = value;
				// await this.searchDocuments(this.tablesData.currentProject.id);
				// await this.searchDocuments(this.tablesData.currentProject.id, false);
				await this.searchDocuments(this.tablesData.currentProject.id, this.isSupervisor ? null : false);
				await this.searchPackages(this.tablesData.currentProject.id);
				this.projectField.value = value;
				this.projectField.validationState = true;
				this.resetDocument();
				this.resetReferenceItem();
			},
			resetProject() {
				this.tablesData.currentProject = null;
				this.tablesData.packages = [];
				this.projectField.value = this.projectField.defaultValue;
				this.projectField.validationState = false;
				this.resetDocument();
				this.resetReferenceItem();
			},
			async assignedDocument(value) {
				this.tablesData.currentDocument = value;
				// await this.searchReferenceItems(this.tablesData.currentProject.id, this.tablesData.currentDocument.id);
				// await this.searchReferenceItems(this.tablesData.currentProject.id, this.tablesData.currentDocument.id, false);
				await this.searchReferenceItems(this.tablesData.currentProject.id, this.tablesData.currentDocument.id, this.isSupervisor ? null : false);
				this.documentField.value = value;
				this.documentField.validationState = true;
				this.resetReferenceItem();
			},
			resetDocument() {
				this.tablesData.currentDocument = null;
				this.documentField.value = this.documentField.defaultValue;
				this.documentField.validationState = false;
				this.resetReferenceItem();
			},
			async assignedReferenceItem(value) {
				this.tablesData.currentReferenceItem = value;
				this.referenceItemField.value = value;
				this.referenceItemField.validationState = true;
			},
			resetReferenceItem() {
				this.tablesData.currentReferenceItem = null;
				this.referenceItemField.value = this.documentField.defaultValue;
				this.referenceItemField.validationState = false;
			},
			manageProject() {
				this.$router.push("/project/management/" + this.tablesData.currentProject.id + 
					"?incoming="+this.isIncoming+
					"&outgoing="+this.isOutgoing+
					"&picking="+this.isPicking+
					"&revision="+this.isRevision+
					"&locked="+this.isLocked+
					"&document="+this.tablesData.currentDocument.id+
					"&referenceItem="+this.tablesData.currentReferenceItem.id
				);
			},
			assignedPackage(value) {
				this.tablesData.currentPackage = value;
				this.itemContentsModalReprint[this.itemContentModalReprint.labelName].value = value;
				this.itemContentsModalReprint[this.itemContentModalReprint.labelName].validationState = true;
			},
			resetPackage() {
				this.tablesData.currentPackage = null;
				this.itemContentsModalReprint[this.itemContentModalReprint.labelName].value = this.itemContentsModalReprint[this.itemContentModalReprint.labelName].defaultValue;
				this.itemContentsModalReprint[this.itemContentModalReprint.labelName].validationState = false;
			},
			async addPackageAndPrintLabel(labelQty) {
				let success = true;
				for (let i = 0, l = labelQty; i < l; i++) {
					let addPackageState = await this.addPackage();
					if (addPackageState && this.canPrint) {
						await this.getPrinter(this.printerId)
						if (this.tablesData.currentPrinter.is_online == true) {
							await this.executePrinterAction(`printers/` + this.printerId + `?do=print_single_barcode` + `&barcode=` + this.tablesData.currentPackage.name)
							.then(() => {})
							.catch(error => {
								success = false;
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
							})
						}
						else {
							success = false;
							this.showMsgWarning(this.messageTitlePrint, this.warningPrinterOffline);
						}
					}
				}
				if (success == true) {
					if (this.canPrint) {
						this.showMsgInfo(this.messageTitleInsert, this.successAddPackageMessage + "<br><br>" + this.successPrintMessage + "&nbsp" + labelQty);
					}
					else {
						this.showMsgInfo(this.messageTitleInsert, this.successAddPackageMessage);
					}
				}
			},
			async reprintLabel() {
				if (!!this.tablesData.currentPackage && this.canPrint) {
					await this.getPrinter(this.printerId) //this.printerId
					if (this.tablesData.currentPrinter.is_online == true) {
						await this.executePrinterAction(`printers/` + this.printerId + `?do=print_single_barcode` + `&barcode=` + this.tablesData.currentPackage.name)
						.then(() => { this.showMsgInfo(this.messageTitleReprint, this.successReprintMessage + "&nbsp" + this.tablesData.currentPackage.name); })
						.catch(error => {
							this.checkUserSession(error, "warning");
							this.showMsgError(this.messageTitleReprint, this.errorPrintMessage);
						})
					}
					else {
						this.showMsgWarning(this.messageTitleReprint, this.warningPrinterOffline);
					}
				}
			},
			async addPackage() {
				this.tablesData.currentPackage = null;
				await this.createPackage(this.prepareNewPackage(),false);
				await this.searchPackages(this.tablesData.currentProject.id);
				if (this.tablesData.currentPackage != null) return true; else return false;
			},
			prepareNewPackage() {
				let myRecord = {
					packages: {
						project_id: this.tablesData.currentProject.id,
						closed: false,
						shipped: false,
					}
				};
				return myRecord;
			},
			async checkProjects() {
				let foundElement = this.tablesData.projects.find((element) => element.name == this.lastBarcode);
				if (!foundElement) this.showMsgWarning(this.messageSearchProjectTitle, this.lastBarcode + " - " + this.messageSearchProjectNotFound);
				else await this.assignedProject(foundElement);
			},
			async checkDocuments() {
				let foundElement = this.tablesData.documents.find((element) => element.name == this.lastBarcode);
				if (!foundElement) this.showMsgWarning(this.messageSearchDocumentTitle, this.lastBarcode + " - " + this.messageSearchDocumentNotFound);
				else await this.assignedDocument(foundElement);
			},
			async checkReferenceItems() {
				let foundElement = this.tablesData.referenceItems.find((element) => element.name == this.lastBarcode);
				if (!foundElement) this.showMsgWarning(this.messageSearchReferenceItemTitle, this.lastBarcode + " - " + this.messageSearchReferenceItemNotFound);
				else await this.assignedReferenceItem(foundElement);
			},
			async checkProjectsOrDocuments() {
				let foundElement = this.tablesData.projects.find((element) => element.name == this.lastBarcode);
				if (!foundElement) {
					foundElement = this.tablesData.documents.find((element) => element.name == this.lastBarcode);
					if (!foundElement) this.showMsgWarning(this.messageSearchProjectOrDocumentTitle, this.lastBarcode + " - " + this.messageSearchProjectOrDocumentNotFound);
					else await this.assignedDocument(foundElement);
				}
				else {
					await this.assignedProject(foundElement);
				}
			},
			async checkDocumentssOrProjects() {
				let foundElement = this.tablesData.documents.find((element) => element.name == this.lastBarcode);
				if (!foundElement) {
					foundElement = this.tablesData.projects.find((element) => element.name == this.lastBarcode);
					if (!foundElement) this.showMsgWarning(this.messageSearchDocumentOrProjectTitle, this.lastBarcode + " - " + this.messageSearchDocumentOrProjectNotFound);
					else await this.assignedProject(foundElement);
				}
				else {
					await this.assignedDocument(foundElement);
				}
			},
			async committedBarcode() {
				switch(true) {
					case (this.projectField.value == this.projectField.defaultValue):
						await this.checkProjects();
						break;
					case (this.documentField.value == this.documentField.defaultValue):
						await this.checkDocuments(); //checkDocumentssOrProjects
						break;
					case (this.referenceItemField.value == this.referenceItemField.defaultValue):
					default:
						await this.checkReferenceItems();
						break;
				}
			},
		},
	});
</script>